// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'report.page.title.tax_statement': 'Tax Statement',
    'report.page.title.sales_tax_return_summary': 'Sales Tax Return Summary (VAT / GCT / GST)',
    'report.page.title.income_tax_summary': 'Income Tax Summary',
    'report.banner.not_a_filing':
        'Informational worksheet to help complete your local tax return. This is not a tax filing.',
    'report.label.tax': 'Tax',
    'report.label.rate': 'Rate',
    'report.label.taxable_sales': 'Taxable Sales',
    'report.label.output_tax': 'Output Tax',
    'report.label.taxable_purchases': 'Taxable Purchases',
    'report.label.input_tax': 'Input Tax',
    'report.label.net_tax': 'Net Tax',
    'report.label.total': 'Total',
    'report.label.informational_only': '(informational only)',
};
